import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import {DocumenttypeService} from 'app/services/documenttype.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';


@Component({
  selector: 'app-list-document-type',
  templateUrl: './list-document-type.component.html',
  styleUrls: ['./list-document-type.component.scss']
})
export class ListDocumentTypeComponent implements OnInit {

  vDocTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;  
  lblHeading = '';

  popoverTitle = 'Delete Document Type';
  popoverMessage = 'Are you sure you want to delete Document Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Document Types...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: DocumenttypeService,
     public utility: UtilityServiceService,private toastService:ToastNotificationService, private toastr:ToastrService) {

     }

  ngOnInit() {
    this.onChangeHeading();
    this.reload();
    this.utility.page = 1;
  }
  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.vDocTypes = result;
      this.utility.onSort(1);
      //console.log(this.vDocTypes);
      this.isLoading = false;
    }, error => {
      console.dir(error);
      this.isLoading = false;
      this.isEmpty = true;
    });

  }

  onChangeHeading(change: boolean = true){
    this.lblHeading = (change) ? 'Document Types' : 'Delete Document Type';
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeading();
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Document Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeading(false);
    this.isRemove = true;
  }
  onSort() {
    this.direction = !this.direction;
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Document Type', message: `Document Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastService.success(`Document Type ${this.removeRef.code} deleted.`,'Delete Document Type');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeading();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Document Type', message: `Document Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastService.error(`Document Type ${this.removeRef.code} was not deleted.`,'Delete Document Type');
    });
  }
}
